var exports = {
  "kL": "x43aef4ae--3e3c9a--container",
  "ZZ": "x43aef4ae--3e3c9a--field",
  "tu": "x43aef4ae--3e3c9a--adornment",
};

module.exports = exports;
